import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Base64MagicNumber } from "../types";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { VisibilityRounded } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

interface CBImageProps {
    imgBase64: string | null,
    title?: string | null
}

const CBImage = ({ imgBase64, title }: CBImageProps) => {

    const { t } = useTranslation("customerbase");
    const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);
    const [openImageDialog, setOpenImageDialog] = useState(false);

    const generateSrc = (src: string) => {

        if(src.substring(0,4) == Base64MagicNumber.JPG_JPEG)
            return `data:image/jpeg;base64, ${src}`
        
        if(src.substring(0,11) == Base64MagicNumber.PNG)
            return `data:image/png;base64, ${src}`

    }

    useEffect(() => {
        setImgSrc(!!imgBase64 ? generateSrc(imgBase64) : undefined);

    }, [imgBase64])


    return (
        <>
            {!!imgBase64 ?
                    <Grid container>
                        <Grid item xs={12}>
                            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                <Typography variant="body1" color="primary">{title}</Typography>
                                <IconButton
                                    title={t("tooltips.document.showImg")}
                                    color="accent"
                                    onClick={() => setOpenImageDialog(true)}
                                >
                                    <VisibilityRounded />
                                </IconButton>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{width: "100%", height: 250, backgroundColor: "whitesmoke" }}>
                                <img 
                                    src={imgSrc}
                                    alt="X" 
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    //onClick={() => downloadFile(frontPageUri)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                : 
                    <Box sx={{width: "100%", height: 250, backgroundColor: "whitesmoke", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography>{t("emptyState.noAvailableDocument")}</Typography>
                    </Box>  
                
            }
            <Dialog
                open={openImageDialog}
                onClose={() => setOpenImageDialog(false)}
                fullWidth
                maxWidth="lg"
            >
                <DialogContent>
                    <img 
                        src={imgSrc}
                        alt="X" 
                        style={{ width: '100%'}}
                        //onClick={() => downloadFile(frontPageUri)}
                    />
                </DialogContent>
                
            </Dialog>
        </>
    )

}

export default CBImage;